<template>
   <v-layout row wrap align-start class="">
    <v-flex align-center xs12 mt-4 class='mt-20 text-xs-center'>
      <div v-if="userfile.name" mt-4>
        <h2>Download {{ userfile.name }}</h2>
        <div>
          <p>
            <a @click.prevent="downloadFile">Click here if {{ userfile.name }} fails to download automatically.</a>
          </p>
        </div>
      </div>
      <div v-else>
        <p><h1>Unable to locate this file.</h1></p>
      </div>
    </v-flex>
   </v-layout>
</template>

<style lang="scss" scoped>
  @import "src/styles/variables.scss";
</style>

<script>

export default {
  components: { },
  data() {
    return {
      userfile: {},
      path: null,
      directory: null,
      filename: null
    };
  },
  methods: {
    downloadFile() {
      this.$http.get(this.userfile.full_url).then(response => {
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.setAttribute('download', this.userfile.name);
        tempLink.href = window.URL.createObjectURL(new Blob([response.data]));
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      });
    }
  },
  computed: {
    filepath() {
      return process.env.VUE_APP_FILE_BASE + this.userfile.full_url;
    }
  },
  mounted() {
    this.path = this.$route.query.path;

    if (this.path) {
      this.directory = this.path.split('/', this.path.split('/').length - 1).reduce((a, b) => { return a += '/' + b; });
      this.filename = this.path.replace(this.directory + '/', '');
    } else {
      this.directory = this.$route.query.directory;
      this.filename = this.$route.query.filename;
    }

    if (this.directory && this.filename) {
      this.$http.get("userfiles/find?directory=" + this.directory + "&filename=" + this.filename).then(
        response => {
          this.userfile = response.data.data;
          this.downloadFile();
        },
        response => {
          console.log("Error pulling userfile.");
        }
      );
    }
  }
};
</script>
